import { Pipe, PipeTransform } from '@angular/core';
import { Tag } from '@zero/tags/domain';

@Pipe({
  name: 'tagsByEntity',
  standalone: true,
})
export class TagsByEntityPipe implements PipeTransform {
  public transform = (tags: Tag[], entityId: string) =>
    tags ? tags.filter(({ entities }) => entities.some(({ entityId: id }) => id === entityId)) : [];
}
